import { Client } from '../../../../../../projects/kiene-core/src/lib/components/client/classes/client';

export class GruppeAuswaehlenDialogInput2 {
    client: Client;
}
